import { useContext } from "react";
import { FeatureFlagContext } from "@context/FeatureFlagContext";

export const useFeatureFlag = () => useContext(FeatureFlagContext);
